import React from "react";
import { Modal, Button } from "antd";

class BackButtonWithConfirmation extends React.Component<{ history: any, title: any , styles?: React.CSSProperties }> {
    showConfirmation = () => {
        Modal.confirm({
            title: "Are you sure?",
            content: "Do you really want to go back? Any unsaved changes will be lost.",
            okText: "Yes",
            cancelText: "No",
            onOk: () => {
                this.props.history.goBack();
            },
        });
    };

    render() {
        return (
            <Button
                style={this.props.styles}
                type="primary"
                onClick={this.showConfirmation}
            >
                {this.props.title}
            </Button>
        );
    }
}

export default BackButtonWithConfirmation;
